// src/components/DateRangePicker.tsx

import * as React from "react";
import { addDays, format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { DateRange } from "react-day-picker";

// --- CHANGE START ---
// Corrected all import paths
import { cn } from "../components/ui/utils"; // Path to lib folder
import { Button } from "./ui/button";
import { Calendar } from "./ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "./ui/popover";
// --- CHANGE END ---


interface DateRangePickerProps extends React.ComponentProps<"div"> {
  date?: DateRange;
  onDateChange: (date?: DateRange) => void;
}

export function DateRangePicker({ className, date, onDateChange }: DateRangePickerProps) {
  const handlePreset = (days: number) => {
    const today = new Date();
    onDateChange({
        from: addDays(today, -days),
        to: today
    });
  }

  return (
    <div className={cn("grid gap-2", className)}>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            id="date"
            variant={"outline"}
            className={cn(
              "w-full justify-start text-left font-normal",
              !date && "text-muted-foreground"
            )}
          >
            <CalendarIcon className="w-4 h-4 mr-2" />
            {date?.from ? (
              date.to ? (
                <>
                  {format(date.from, "LLL dd, y")} -{" "}
                  {format(date.to, "LLL dd, y")}
                </>
              ) : (
                format(date.from, "LLL dd, y")
              )
            ) : (
              <span>Pick a date range</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="flex w-auto p-0" align="start">
          <div className="flex flex-col p-2 pr-4 border-r">
             <Button variant="ghost" className="justify-start" onClick={() => handlePreset(0)}>Today</Button>
             <Button variant="ghost" className="justify-start" onClick={() => handlePreset(6)}>Last 7 days</Button>
             <Button variant="ghost" className="justify-start" onClick={() => handlePreset(29)}>Last 30 days</Button>
             <Button variant="ghost" className="justify-start" onClick={() => onDateChange(undefined)}>All Time</Button>
          </div>
          <Calendar
            initialFocus
            mode="range"
            defaultMonth={date?.from}
            selected={date}
            onSelect={onDateChange}
            numberOfMonths={2}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}